/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-10-16 10:53:46
 */
const menus = [
	/** 病历管理-病例列表 */
	{
		name: ['Index'],
    	path: '/',
		component: resolve => require(['@/views/index/index.vue'], resolve),
		meta: {
			title:['病例列表'],
			noTab: true,
			show: true,//是否在左侧menu中显示
			icon: 'icon-binglimoban',
			groupType:'病历管理',
			groupTitle: '病历管理'
        }
	},
	// 病历管理-新建病例
	{
		name: ['newCase'],
		path: '/newCase',
		component: resolve => require(['@/views/newCase/index.vue'], resolve),
		meta: {
			title:['新建病例'],
			noTab: true,
			show: false,
			groupType: '病历管理'
		}
	},
	// 病历管理-病例详情
	{
		name: ['caseDetail'],
		path: '/case_detail/:bid',
		component: resolve => require(['@/views/caseDetail/index.vue'], resolve),
		meta: {
			title:['病例详情'],
			noTab: true,
			show: false,
			groupType: '病历管理'
		}
	},
	// 病历管理-病例详情--上传文件结果
	{
		name: ['caseDetailUpload'],
		path: '/case_detail/upload/:bid',
		component: resolve => require(['@/views/caseDetail/uploadFile.vue'], resolve),
		meta: {
			title:['病例详情','结果文件上传'],
			noTab: true,
			show: false,
			groupType: '病历管理'
		}
	},
	// 病历管理-病例详情--分析结果
	{
		name: ['caseDetailResult'],
		path: '/case_detail/analysis_result/:bid',
		component: resolve => require(['@/views/caseDetail/analysisResult/index.vue'], resolve),
		meta: {
			title:['病例详情','分析结果'],
			noTab: true,
			show: false,
			groupType: '病历管理'
		}
	},
	/**账号信息 */
  {
		name: ['account'],
		path: '/account',
		component: resolve => require(['@/views/account/index.vue'], resolve),
		meta: {
			title:['账号信息'],
			noTab: true,
			show: true,
			icon: 'icon-yonghuming',
			groupTitle: '帐号设置',
			groupType:'帐号设置',
		}
	},
	/**修改密码 */
	{
		name: ['editPwd'],
		path: '/edit-pwd',
		component: resolve => require(['@/views/editPwd/index.vue'], resolve),
		meta: {
			title:['修改密码'],
			noTab: true,
			show: true,
			icon: 'icon-password',
			groupType:'帐号设置',
		}
	}
]

export default menus



// WEBPACK FOOTER //
// ./src/routes/menu.js